import { useEffect } from 'react';

import { useReportError } from '@/hooks/useReportError';
import { usePresentationApprovalWorkflowEnabled } from '@/modules/tenant/TenantDetailsContext/hooks/usePresentationApprovalWorkflowEnabled';

import { useSetEmployeeLastViewedPresentationApprovalsAtMutation } from './graphql/PresentationApprovalBadge.generated';

/**
 * useMarkPresentationApprovalsViewed records that the current user viewed
 * the presentation approvals list when isViewing becomes true. The mutation
 * returns the employee with a count of 0, so Apollo clears the Tasks badge.
 */
export function useMarkPresentationApprovalsViewed(isViewing: boolean) {
  const isWorkflowEnabled = usePresentationApprovalWorkflowEnabled();
  const { reportError } = useReportError();
  const [markViewed] =
    useSetEmployeeLastViewedPresentationApprovalsAtMutation();

  useEffect(() => {
    if (!isWorkflowEnabled || !isViewing) return;
    markViewed().catch((error: Error) =>
      reportError('Failed to mark presentation approvals viewed', error)
    );
  }, [isWorkflowEnabled, isViewing, markViewed, reportError]);
}
